import requests from "./httpService";

const CarServices = {

    getService: async () =>{
        return requests.get(`/service`);
    },
    getServiceWeb: async () =>{
        return requests.get(`/service/landing`);
    },
    updateService : async (id,body) =>{
        return requests.patch(`/service/${id}`,body);
    },

    createService : async (body) =>{
   
        return requests.post(`/service`,body);
    },
    deleteService : async (id) =>{
        return requests.delete(`/service/${id}`);
    },
    
    uploadImage : async (body) =>{

        return requests.post(`/service/uploadImage`,body);
    },
    removeImage : async (body) =>{
        return requests.post(`/service/removeImage`,body);
    }

}
export default CarServices;